import { COLORS } from 'shared/consts';
import { createGlobalStyle } from 'styled-components';
import '@atomaro/ui-kit/theme/default-light.css'
import { ATOMARO_STYLES, ATOMARO_VARIABLE_STYLES } from 'shared/consts/styleValues';

export const GlobalStyle = createGlobalStyle`
  :root {
    ${ATOMARO_VARIABLE_STYLES};
    font-family: var(--font-family);
    font-weight: 400;

    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    padding: 0px;
    margin: 0px;
    border: 0px;
    transition: background-color 0.4s ease;
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  *::before,
  *::after {
    display: inline-block;
  }
  :focus,
  :active {
    // outline: none;
  }
  a:focus,
  a:active {
    // outline: none;
  }
  html,
  body {
    height: 100%;
    font-size: 16px;
  }
  body {
    color: ${COLORS.FG.DEFAULT};
    background-color: var(--body-bg);
    line-height: 1;
    -ms-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;

    &:has(>[aria-modal="true"]) {
      .MobileBottomWrapper {
        z-index: 11;
      }
    }
  }
  input,
  button,
  textarea {
    font-family: "Rostelecom Basis", Arial, Helvetica, sans-serif;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
    background-color: transparent;
  }

  input,
  textarea {
    width: 100%;
  }

  label {
    display: inline-block;
  }

  button,
  select,
  option {
    cursor: pointer;
  }
  a {
    display: inline-block;
    color: inherit;
    text-decoration: none;
  }
  ul li {
    list-style: none;
  }
  img {
    vertical-align: top;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: inherit;
    font-size: inherit;
  }

  

  #root {
    overflow-x: clip;
  }

  ._skeleton {
    overflow: hidden;
    position: relative;
    pointer-events: none;
    >* {
      position: relative;
      z-index: 1;
    }

    &::before{
      content:'';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #d8d8d8;
      z-index: 2;
    }
    
    &::after{
      content:'';
      position: absolute;
      top: -5%;
      left: calc(100% + 60px);
      width: 40px;
      height: 110%;
      rotate: 15deg;
      background-color: #fff;
      box-shadow: 0px 0px 10px 10px rgba(255, 255, 255, 1);
      z-index: 3;
      opacity: 0.4;
      animation: skeletonAfterAnim 1s ease infinite;
    }
  }

  @keyframes skeletonAfterAnim {
    from {
        left: -3.75rem
    }
  }

  .Toastify__close-button--light {
    color: ${COLORS.FG.DEFAULT};
  }
  
    .settingsPopupTable {
      inset: -16px 0px auto auto!important;
    }

  ${ATOMARO_STYLES}
`;
